<template>
  <div class="home">
    <div>
      <!-- header -->
      <section>
        <div class="py-8 px-8">
          <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div class="col-12 col-lg-auto mb-3 mb-lg-0">
              <div class="d-flex align-items-center">
                <h4 class="mb-0 me-2">{{$t('plannings')}}</h4>
              </div>
            </div>
            <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
              <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')" @input="debounceSearch">
              </div>
              <!-- Mobile filter toggle -->
              <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                <AppIcon name="bi-funnel" class="bi bi-funnel" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- table -->
      <section>
        <div class="px-8">
          <!-- Mobile action buttons -->
          <div class="d-flex d-md-none gap-2 mb-3">
            <button @click="showAddModal = true" class="btn btn-sm btn-success flex-grow-1">
              <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
              <span>{{$t('create_planning')}}</span>
            </button>
          </div>

          <!-- Filters section (collapsible on mobile, always visible on desktop) -->
          <div class="row align-items-end g-2 mb-4" :class="{'d-none d-md-flex': !showFilters}">
            <!-- Filter Dropdown (Shopify Style) -->
            <div class="col-12 col-md-auto">
              <div class="dropdown">
                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="filterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                  <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                  <span v-if="activeFilterCount" class="badge bg-secondary ms-1">{{activeFilterCount}}</span>
                </button>
                <button v-if="activeFilterCount" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                  <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                </button>
                <div class="dropdown-menu p-3" aria-labelledby="filterDropdown" style="min-width: 300px;" @click.stop>
                  <!-- Active Filters -->
                  <div v-if="activeFilters.length > 0" class="mb-3">
                    <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                      <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                      <div class="input-group input-group-sm">
                        <select v-if="filter.type === 'select'" v-model="filter.value" class="form-select form-select-sm">
                          <option value="">{{$t('all')}}</option>
                          <option v-for="opt in filter.options" :key="opt.value" :value="opt.value">{{$t(opt.label)}}</option>
                        </select>
                        <input v-else type="text" v-model="filter.value" class="form-control form-control-sm" :placeholder="$t(filter.key)">
                        <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                          <AppIcon name="bi-trash" class="bi bi-trash" />
                        </button>
                      </div>
                    </div>
                    <hr class="dropdown-divider">
                  </div>

                  <!-- Add Filter Options -->
                  <div class="d-grid gap-2">
                    <button v-for="filter in selectableFilters" :key="filter.key" class="btn btn-sm btn-outline-primary text-start" @click="addFilter(filter)">
                      <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                    </button>
                  </div>

                  <!-- Apply and Clear -->
                  <div class="d-flex justify-content-between align-items-center mt-3">
                    <button class="btn btn-sm btn-success" @click="applyFilters">{{$t('apply')}}</button>
                    <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">{{$t('clear_all')}}</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Spacer for desktop -->
            <div class="col d-none d-md-block"></div>

            <!-- Date picker -->
            <!-- <div class="col-12 col-md-3 col-lg-2">
              <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
              <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                <option value="">{{$t('filter_by_date')}}</option>
                <option value="today">{{$t('today')}}</option>
                <option value="yesterday">{{$t('yesterday')}}</option>
                <option value="this_week">{{$t('this_week')}}</option>
                <option value="last_week">{{$t('last_week')}}</option>
                <option value="this_month">{{$t('this_month')}}</option>
                <option value="custom">{{$t('custom_date')}}</option>
              </select>
            </div>
            <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
              <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
              <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :lang="datePickerLocale" :placeholder="$t('select_date_range')"></date-picker>
            </div> -->

            <!-- View switcher -->
            <!-- <div class="col-12 col-md-auto">
              <div class="dropdown">
                <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="viewDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                  <AppIcon :name="currentView === 'list' ? 'bi bi-list-ul' : 'bi bi-calendar3'" :class="currentView === 'list' ? 'bi bi-list-ul' : 'bi bi-calendar3'" />
                  <span class="ms-1">{{ $t(currentView) }}</span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="viewDropdown">
                  <li>
                    <button class="dropdown-item" :class="{active: currentView === 'list'}" @click="currentView = 'list'">
                      <AppIcon name="bi-list-ul" class="bi bi-list-ul me-2" />{{ $t('list') }}
                    </button>
                  </li>
                  <li>
                    <button class="dropdown-item" :class="{active: currentView === 'calendar'}" @click="currentView = 'calendar'">
                      <AppIcon name="bi-calendar3" class="bi bi-calendar3 me-2" />{{ $t('calendar') }}
                    </button>
                  </li>
                </ul>
              </div>
            </div> -->

            <!-- Desktop create button -->
            <div class="col-md-2 d-none d-md-block">
              <button @click="showAddModal = true" class="btn btn-sm btn-success w-100">
                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                <span>{{$t('create_planning')}}</span>
              </button>
            </div>
          </div>

          <div v-if="currentView === 'calendar'" class="mb-6">
            <my-planning-calendar
              :plannings="plannings"
              @open-detail="openDetailModal"
              @create-planning="createPlanningForDate"
              @month-change="handleCalendarMonthChange"
            />
          </div>

          <div v-else class="page-table-container planning-table-card mb-6 bg-white rounded shadow-sm">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table mb-0 table-borderless table-striped small">
                <thead>
                  <tr class="text-secondary">
                    <th class="pt-5 pb-4 px-8" style="width: 40px;">
                      <div class="form-check mb-0">
                        <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                      </div>
                    </th>
                    <sortable-table-header v-if="visibleColumns.id" field="id" label="id" :sort-field="sortField" :sort-direction="sortDirection" header-class="pt-5 pb-4 px-8" @sort="applySort($event, refresh)" />
                    <sortable-table-header v-if="visibleColumns.title" field="title" label="title" :sort-field="sortField" :sort-direction="sortDirection" header-class="pt-5 pb-4 px-8" @sort="applySort($event, refresh)" />
                    <th v-if="visibleColumns.assigned_to" class="pt-5 pb-4 px-8">{{$t('assigned_to')}}</th>
                    <th v-if="visibleColumns.client" class="pt-5 pb-4 px-8">{{$t('client')}}</th>
                    <sortable-table-header v-if="visibleColumns.date" field="date" label="date" :sort-field="sortField" :sort-direction="sortDirection" header-class="pt-5 pb-4 px-8" @sort="applySort($event, refresh)" />
                    <sortable-table-header v-if="visibleColumns.address" field="address" label="address" :sort-field="sortField" :sort-direction="sortDirection" header-class="pt-5 pb-4 px-8" @sort="applySort($event, refresh)" />
                    <sortable-table-header v-if="visibleColumns.status" field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" header-class="pt-5 pb-4 px-8" @sort="applySort($event, refresh)" />
                    <sortable-table-header v-if="visibleColumns.priority" field="priority" label="priority" :sort-field="sortField" :sort-direction="sortDirection" header-class="pt-5 pb-4 px-8" @sort="applySort($event, refresh)" />
                    <sortable-table-header v-if="visibleColumns.created_at" field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" header-class="pt-5 pb-4 px-8" @sort="applySort($event, refresh)" />
                    <th v-if="visibleColumns.action" class="pt-5 pb-4 px-8">
                      <div class="d-flex align-items-center justify-content-between">
                        <span>{{$t('action')}}</span>
                        <div class="dropdown">
                          <button class="btn btn-sm btn-link p-0 ms-2" type="button" data-bs-toggle="dropdown" aria-expanded="false" :title="$t('columns')" :aria-label="$t('columns')">
                            <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end p-2" style="min-width: 200px; max-height: 300px; overflow-y: auto;">
                            <li v-for="(val, key) in visibleColumns" :key="key">
                              <div class="form-check dropdown-item">
                                <input class="form-check-input" type="checkbox" v-model="visibleColumns[key]" :id="'col-' + key">
                                <label class="form-check-label w-100" :for="'col-' + key">
                                  {{$t(key)}}
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in plannings" :key="p.id" :class="{'table-active': p.selected}" class="planning-row" @click="openDetailModal(p)">
                    <td class="py-6 px-8" @click.stop>
                      <div class="form-check mb-0">
                        <input class="form-check-input" type="checkbox" v-model="p.selected" @change="changeSelectedItem">
                      </div>
                    </td>
                    <td v-if="visibleColumns.id" class="py-6 px-8">
                      <span class="planning-id">#{{ p.id.toString().substring(0, 8) }}</span>
                    </td>
                    <td v-if="visibleColumns.title" class="py-6 px-8">
                      <strong class="planning-title">{{ p.title }}</strong>
                    </td>
                    <td v-if="visibleColumns.assigned_to" class="py-6 px-8">
                      <span v-if="p.assignedUser && p.assignedUser.name">{{ p.assignedUser.name }}</span>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td v-if="visibleColumns.client" class="py-6 px-8">
                      <span v-if="p.client && p.client.name">{{ p.client.name }}</span>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td v-if="visibleColumns.date" class="py-6 px-8">
                      {{ formatDate(p.date) }}
                      <div v-if="p.start_time" class="text-muted small">{{ p.start_time }} - {{ p.end_time || '??' }}</div>
                    </td>
                    <td v-if="visibleColumns.address" class="py-6 px-8">
                      {{ p.address || '-' }}
                    </td>
                    <td v-if="visibleColumns.status" class="py-6 px-8">
                      <span :class="'planning-badge planning-badge--' + getStatusColor(p.status)">{{ $t(p.status) }}</span>
                    </td>
                    <td v-if="visibleColumns.priority" class="py-6 px-8">
                      <span :class="'planning-badge planning-badge--' + getPriorityColor(p.priority)">{{ $t(p.priority) }}</span>
                    </td>
                    <td v-if="visibleColumns.created_at" class="py-6 px-8">
                      {{ formatDate(p.created_at) }}
                    </td>
                    <td v-if="visibleColumns.action" class="py-6 px-8" @click.stop>
                      <button @click="edit(p)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-outline-primary btn-xs">
                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                        {{$t('edit')}}
                      </button>
                      <button @click="deletePlanning(p)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-outline-danger btn-xs">
                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                        {{$t('delete')}}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="count > plannings.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                <compact-pagination :pages="pagination" :current-page="page" @change="loadPage" />
              </div>
            </div>
            <table-loading-bar v-if="loading" class="page-table-state text-center" />
            <div v-if="loading === false && !plannings.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
              <AppIcon name="bi-calendar-range" class="bi bi-calendar-range text-muted" style="font-size: 3rem;" />
              <h4 class="mt-3">{{$t('no_plannings_found')}}</h4>
              <p class="text-muted">{{$t('create_first_planning')}}</p>
              <button class="btn btn-outline-primary mt-2" @click="showAddModal = true">
                {{$t('create_planning')}}
              </button>
            </div>
            <div v-if="loading === false && !plannings.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_plannings_found')}}.</div>
          </div>

          <div v-if="currentView === 'list'" class="col-sm-7">
            {{$t('show')}}
            <select v-model="per_page" @change="refresh" class="form-select mb-3" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            {{$t('entities')}}
          </div>
        </div>
      </section>
    </div>

    <!-- Bulk Action Bar -->
    <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
        <div class="d-flex align-items-center">
            <span class="fw-bold me-2">{{ selectedCount }}</span>
            <span class="text-muted">{{$t('selected')}}</span>
        </div>
        <div class="d-flex gap-2">
            <button class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
            </button>
        </div>
    </div>

    <!-- Modal -->
    <AddEditPlanningModal
      v-if="showAddModal"
      :planning="selectedPlanning"
      :initial-date="selectedPlanningDate"
      @close="closeModal"
      @refresh="refresh"
    />

    <PlanningDetailModal
      v-if="detailPlanning"
      :planning="detailPlanning"
      :loading="detailLoading"
      :editable="canEditPlanning"
      :deletable="canDeletePlanning"
      :deleting="detailDeleting"
      @close="closeDetailModal"
      @edit="editFromDetail"
      @delete="deletePlanning"
    />
  </div>
</template>

<script>
import helper from '../../helper'
import AddEditPlanningModal from '../../components/planning/AddEditPlanningModal.vue'
import MyPlanningCalendar from '../../components/planning/MyPlanningCalendar'
import PlanningDetailModal from '../../components/planning/PlanningDetailModal.vue'
// import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/fr'
import 'vue2-datepicker/locale/ar'
import moment from 'moment'
import sortableList from '../../mixins/sortableList'

export default {
  name: 'PlanningList',
  persistedFilterState: {
    key: 'planning-list',
    fields: ['search', 'activeFilters', 'dateRangeOption', 'range', 'start_date', 'end_date', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components: {
    AddEditPlanningModal,
    MyPlanningCalendar,
    PlanningDetailModal,
    //DatePicker
  },
  data() {
    return {
      helper,
      loading: false,
      plannings: [],
      users: [],
      search: '',
      page: 1,
      per_page: 15,
      count: 0,
      showAddModal: false,
      showFilters: false,
      selectedPlanning: null,
      selectedPlanningDate: '',
      detailPlanning: null,
      detailLoading: false,
      detailDeleting: false,
      detailRequestId: 0,
      calendarRange: null,
      refreshRequestId: 0,
      searchTimeout: null,
      dateRangeOption: '',
      currentView: localStorage.getItem('planning_list_view') || 'calendar',
      range: [],
      start_date: '',
      end_date: '',
      activeFilters: [],
      visibleColumns: {
        id: true,
        title: true,
        assigned_to: true,
        client: true,
        date: true,
        address: true,
        status: true,
        priority: true,
        created_at: true,
        action: true
      },
      isSelectedItem: false,
      availableFilters: [
        {
          key: 'status',
          type: 'select',
          options: [
            { value: 'planned', label: 'planned' },
            { value: 'in_progress', label: 'in_progress' },
            { value: 'completed', label: 'completed' },
            { value: 'failed', label: 'failed' },
            { value: 'postponed', label: 'postponed' }
          ]
        },
        {
          key: 'priority',
          type: 'select',
          options: [
            { value: 'low', label: 'low' },
            { value: 'medium', label: 'medium' },
            { value: 'high', label: 'high' },
            { value: 'urgent', label: 'urgent' }
          ]
        },
        {
          key: 'assigned_to',
          type: 'select',
          options: [] // To be filled in mounted
        },
        {
          key: 'client_id',
          type: 'select',
          options: [] // To be filled in mounted
        },
        {
          key: 'address',
          type: 'text'
        }
      ]
    }
  },
  computed: {
    datePickerLocale() {
      return ['fr', 'ar'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en'
    },
    selectableFilters() {
      const activeKeys = this.activeFilters.map(f => f.key)
      return this.availableFilters.filter(f => !activeKeys.includes(f.key))
    },
    isFiltered() {
      return this.search || this.activeFilters.some(f => f.value) || this.start_date || this.end_date
    },
    activeFilterCount() {
      return this.activeFilters.filter(f => f.value && f.value.toString().trim()).length;
    },
    areAllSelected() {
      return this.plannings.length > 0 && this.plannings.every(p => p.selected);
    },
    selectedCount() {
      return this.plannings.filter(p => p.selected).length;
    },
    pagination() {
      const pages = Math.ceil(this.count / this.per_page)
      const result = []
      for (let i = 1; i <= pages; i++) result.push(i)
      return result
    },
    canEditPlanning() {
      return helper.checkAccess('edit_plannings') !== -1
    },
    canDeletePlanning() {
      return helper.checkAccess('delete_plannings') !== -1
    }
  },
  mounted() {
    //if(helper.checkAccess('view_plannings') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_plannings') == -2) return this.$router.push({path : '/subscribe'})

    window.mixpanel.track("plannings")
    this.refresh()
    this.getUsers()
    this.getClients()
  },
  methods: {
    async refresh() {
      const requestId = ++this.refreshRequestId
      this.loading = true
      try {
        const params = {
          page: this.page,
          per_page: this.currentView === 'calendar' ? 500 : this.per_page,
          search: this.search,
          sort_field: this.sortField,
          sort_type: this.sortDirection
        }
        const activeRange = this.currentView === 'calendar' && this.calendarRange
          ? this.calendarRange
          : { start_date: this.start_date, end_date: this.end_date }
        if (activeRange.start_date) params.start_date = activeRange.start_date
        if (activeRange.end_date) params.end_date = activeRange.end_date

        // Apply active filters to params
        this.activeFilters.forEach(f => {
          if (f.value) {
            if (f.key === 'assigned_to') params.assigned_user_id = f.value
            else params[f.key] = f.value
          }
        })

        const response = await helper.customGet(`${process.env.VUE_APP_API}/plannings`, { params })
        if (requestId !== this.refreshRequestId) return

        this.plannings = response.data.plannings || []

        // Add selected property
        this.plannings.forEach(p => {
          this.$set(p, 'selected', false);
        });

        this.count = response.data.total || 0;
      } catch (error) {
        if (requestId === this.refreshRequestId) alert(this.$t('error_loading_plannings'))
      } finally {
        if (requestId === this.refreshRequestId) this.loading = false
      }
    },
    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.page = 1
        this.refresh()
      }, 500)
    },
    async getUsers() {
      try {
        const res = await helper.customGet(`${process.env.VUE_APP_API}/users`, { params: { per_page: 200 } })
        const assignedFilter = this.availableFilters.find(f => f.key === 'assigned_to')
        if (assignedFilter) {
          assignedFilter.options = (res.data.data || []).map(u => ({ value: u.id, label: u.name }))
        }
      } catch (e) { alert(e) }
    },
    async getClients() {
      try {
        const res = await helper.customGet(`${process.env.VUE_APP_API}/clients`, { params: { per_page: 200 } })
        const clientFilter = this.availableFilters.find(f => f.key === 'client_id')
        if (clientFilter) {
          clientFilter.options = (res.data.data || []).map(c => ({ value: c.id, label: c.name }))
        }
      } catch (e) { alert(e) }
    },
    loadPage(p) {
      this.page = p
      this.refresh()
    },
    addFilter(filter) {
      this.activeFilters.push({ ...filter, value: '' })
    },
    removeFilter(index) {
      this.activeFilters.splice(index, 1)
      this.refresh()
    },
    applyFilters() {
      this.page = 1
      this.refresh()
    },
    clearAllFilters() {
      this.activeFilters = []
      this.page = 1
      this.refresh()
    },
    handleDateRangeChange() {
      const today = moment()
      switch (this.dateRangeOption) {
        case 'today':
          this.range = [today.toDate(), today.toDate()]
          break
        case 'yesterday':
          this.range = [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()]
          break
        case 'this_week':
          this.range = [moment().startOf('week').toDate(), moment().endOf('week').toDate()]
          break
        case 'last_week':
          this.range = [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()]
          break
        case 'this_month':
          this.range = [moment().startOf('month').toDate(), moment().endOf('month').toDate()]
          break
        case 'custom':
          this.range = []
          break
        default:
          this.range = []
          this.start_date = ''
          this.end_date = ''
      }
      this.page = 1
      this.refresh()
    },
    handleCalendarMonthChange(range) {
      this.calendarRange = range
      this.page = 1
      this.refresh()
    },
    createPlanningForDate(date) {
      this.selectedPlanning = null
      this.selectedPlanningDate = date
      this.showAddModal = true
    },
    async openDetailModal(planning) {
      const requestId = ++this.detailRequestId
      this.detailPlanning = planning
      this.detailLoading = true

      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/plannings/${planning.id}`)
        if (requestId === this.detailRequestId && this.detailPlanning && this.detailPlanning.id === planning.id) {
          this.detailPlanning = response.data
        }
      } catch (error) {
        // The list payload still contains the core details, so keep the modal usable.
      } finally {
        if (requestId === this.detailRequestId) this.detailLoading = false
      }
    },
    closeDetailModal() {
      this.detailRequestId += 1
      this.detailPlanning = null
      this.detailLoading = false
    },
    editFromDetail(planning) {
      this.closeDetailModal()
      this.edit(planning)
    },
    // Bulk selection
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.plannings.forEach(p => this.$set(p, 'selected', newState));
      this.changeSelectedItem();
    },
    changeSelectedItem() {
      this.isSelectedItem = this.plannings.find(p => p.selected === true) ? true : false
    },
    async deleteSelected() {
      const selectedIds = this.plannings.filter(p => p.selected).map(p => p.id);
      if (selectedIds.length === 0) return;

      const result = await this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      });

      if (result.isConfirmed) {
        this.loading = true;
        try {
          const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/plannings/${id}`)));
          const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
          this.plannings = helper.withoutDeletedRecords(this.plannings, deletedIds);
          this.count = Math.max(0, this.count - deletedIds.length);
          if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
          this.isSelectedItem = false;
        } catch (e) {
          /* ignore */
        } finally {
          this.loading = false;
        }
      }
    },
    edit(planning) {
      this.selectedPlanning = planning
      this.showAddModal = true
    },
    async deletePlanning(planning) {
      const result = await this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      })
      if (!result.isConfirmed) return

      const isOpenInDetail = Boolean(this.detailPlanning && this.detailPlanning.id === planning.id)
      this.detailDeleting = isOpenInDetail

      try {
        await helper.customDelete(`${process.env.VUE_APP_API}/plannings/${planning.id}`, { showToast: true })
        if (isOpenInDetail) this.closeDetailModal()
        this.plannings = helper.withoutDeletedRecords(this.plannings, planning.id)
        this.count = Math.max(0, this.count - 1)
      } catch (error) {
        // customDelete already displays the API error to the user.
      } finally {
        this.detailDeleting = false
      }
    },
    closeModal() {
      this.showAddModal = false
      this.selectedPlanning = null
      this.selectedPlanningDate = ''
    },
    formatDate(date) {
      if (!date) return '-'
      return helper.formatDate(date)
    },
    getStatusColor(status) {
      return { planned: 'primary', in_progress: 'info', completed: 'success', failed: 'danger', postponed: 'warning' }[status] || 'secondary'
    },
    getPriorityColor(priority) {
      return { low: 'info', medium: 'primary', high: 'warning', urgent: 'danger' }[priority] || 'primary'
    }
  },
  watch: {
    currentView(val, previousView) {
      localStorage.setItem('planning_list_view', val)
      if (previousView === 'calendar' && val !== 'calendar') {
        this.calendarRange = null
        this.page = 1
        this.refresh()
      }
    },
    range() {
      if (this.range[0] == null) {
        this.start_date = null
        this.end_date = null
        this.refresh()
      } else if (this.range.length && this.range[0] && this.range[1]) {
        this.start_date = moment(this.range[0]).format('YYYY-MM-DD')
        this.end_date = moment(this.range[1]).format('YYYY-MM-DD')
        this.refresh()
      }
    }
  }
}
</script>

<style scoped>
.planning-table-card {
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 14px !important;
}

.planning-row {
  cursor: pointer;
  transition: background-color 0.16s ease, transform 0.16s ease;
}

.planning-row:hover {
  background: #f7faff !important;
}

.planning-id {
  color: #0d6efd;
  font-weight: 750;
}

.planning-title {
  color: #1d2939;
  font-weight: 700;
}

.planning-badge {
  display: inline-flex;
  padding: 0.34rem 0.58rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
}

.planning-badge--primary { background: #eef5ff; color: #0d6efd; }
.planning-badge--info { background: #eefaff; color: #087ea4; }
.planning-badge--success { background: #effaf4; color: #198754; }
.planning-badge--warning { background: #fff8e8; color: #b45309; }
.planning-badge--danger { background: #fff1f2; color: #dc3545; }
.planning-badge--secondary { background: #f2f4f7; color: #667085; }

</style>
